/**
 * 描述：租户管理--新建编辑弹框
 * 日期：2017-11-16
 * 作者：liu_jinming
 */
"use strict";
angular.module("checkManuIpModule", [])
    .controller("checkManuIpCtrl", ["$scope", "$modalInstance", "trsHttpService", "modalDialog", "$validation", "$state", function($scope, $modalInstance, trsHttpService, modalDialog, $validation, $state) {
        /** [cancel description]关闭弹窗 */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /** [confirm description]点击确定跳转到稿库接入设置界面 */
        $scope.confirm = function() {
            $state.go('manageconfig.tenantmanagement.manuAccessSetting');
            $modalInstance.dismiss();
        };
    }]);